import { useFetch } from 'context/fetch';
import { useMutation, useQuery } from 'react-query';

import { QUERY_KEY } from './constants';

import { fetchPriceQuery } from './queries';
import {
  getCheckoutSessionIDMutation,
  setSuccessSessionMutation,
} from './mutations';

export const usePriceQuery = (props) => {
  const { key = QUERY_KEY, config = {} } = props || {};
  const { client } = useFetch();

  return useQuery([key], () => fetchPriceQuery({ client }), config);
};

export const useGetCheckoutSessionIDMutation = () => {
  const { client } = useFetch();
  return useMutation(() =>
    getCheckoutSessionIDMutation({
      client,
    })
  );
};

export const useSetSuccessSessionMutation = (props) => {
  const { sessionId } = props || {};
  const { client } = useFetch();
  return useMutation(() =>
    setSuccessSessionMutation({
      client,
      sessionId,
    })
  );
};
